
export const ADD_TO_CART='addToCart';
export const ADD_TO_CART_ERROR='addToCartError';
export const REMOVE_FROM_CART='removeFromCart';
export const CART_RESET='cartReset';
export const UPDATE_CART_ITEM_QUANTITY='UPDATE_CART_ITEM_QUANTITY';